import React from 'react';
import { CCarousel, CCarouselCaption, CCarouselItem, CImage } from '@coreui/react';
import CarouselImage1 from '../assets/carousel-image-1.png';
import CarouselImage2 from '../assets/carousel-image-2.png';
import CarouselImage3 from '../assets/carousel-image-3.png';
import '../styles/HeaderCarousels.css'
import { Link } from 'react-router-dom';

const HeaderCarousels = () => {
    const carouselData = [{ src: CarouselImage1, title: 'Justice Oriented.' },
    { src: CarouselImage2, title: 'Client Focused.' },
    { src: CarouselImage3, title: 'Law Expertise.' }];
    return (
        <header>
            <CCarousel controls className='carousels' indicators>
                {
                    carouselData.map((carousel, index) => {
                        return (
                            <CCarouselItem className='carousel' key={index}>
                                <CImage
                                    className={`carousel_image ${index === 0 ? 'carousel_image-1' : ''}`}
                                    src={carousel.src}
                                    alt='Carousel Slide'
                                />
                                <CCarouselCaption className='carousel_text'>
                                    <h1 className='carousel_title'>{carousel.title}</h1>
                                    <p className='carousel_para'>The best law practices & services for all your legal needs.</p>
                                    <Link to='/contact' className='carousel_link'>Free Evaluation</Link>
                                </CCarouselCaption>
                            </CCarouselItem>
                        )
                    })
                }
            </CCarousel>
        </header>

    );
}

export default HeaderCarousels;